import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  refreshDashboard: false,
  adminPermissionLoading: true, // Start as true until data is loaded
  filterData: null,
  filterDetailsLoading: true, // Start as true until data is loaded
  jurisdiction: [],
  healthCondition: [],
  sdohData: [],
  healthAndEquityConditions: {
    healthEquityConditionList: {healthEquityConditionList: []}
  },
  states: {stateList: []},
  sdoh: {sdohKeys: []},
  currentJurisdiction: [],
  currentDataAggregation: [],
  currentHealthCondition: [],
  currentSdoh: [],
  currentPOI: [],
  currentBenefits: [],
  currentWorkforces: [],
  useCaseConfigData: [],
  currentUseCases: [],
  currentTrendAnalysisFlag: [],
  currentUserFeedbackFlag: [],
  currentChatbotFlag: [],
  currentChatbotExportFlag: [],
  currentChatbotCopyFlag: [],
  currentExportFlag: [],
  currentPersonaFlag: [],
  customLabels: [],
  customizationDefaultData: {},
  customizationData: {
    heCustomLabels: {},
    sdohCustomLabels: [],
    poiCustomLabels: []
  }
}

const adminPermissionSlice = createSlice({
  name: 'adminPermission',
  initialState,
  reducers: {
    setRefreshDashboard: (state, action) => {
      state.refreshDashboard = action.payload
    },
    setAdminPermissionLoading: (state, action) => {
      state.adminPermissionLoading = action.payload
    },
    setFilterData: (state, action) => {
      state.filterData = action.payload
    },
    setJurisdiction: (state, action) => {
      state.jurisdiction = action.payload
    },
    setHealthCondition: (state, action) => {
      state.healthCondition = action.payload
    },
    setSdohData: (state, action) => {
      state.sdohData = action.payload
    },
    setHealthAndEquityConditions: (state, action) => {
      state.healthAndEquityConditions = action.payload
    },
    setStates: (state, action) => {
      state.states = action.payload
    },
    setSdoh: (state, action) => {
      state.sdoh = action.payload
    },
    setCurrentJurisdiction: (state, action) => {
      state.currentJurisdiction = action.payload
    },
    setCurrentDataAggregation: (state, action) => {
      state.currentDataAggregation = action.payload
    },
    setCurrentHealthCondition: (state, action) => {
      state.currentHealthCondition = action.payload
    },
    setCurrentSdoh: (state, action) => {
      state.currentSdoh = action.payload
    },
    setCurrentPOI: (state, action) => {
      state.currentPOI = action.payload
    },
    setCurrentBenefits: (state, action) => {
      state.currentBenefits = action.payload
    },
    setCurrentWorkforces: (state, action) => {
      state.currentWorkforces = action.payload
    },
    setUseCaseConfigData: (state, action) => {
      state.useCaseConfigData = action.payload
    },
    setCurrentUseCases: (state, action) => {
      state.currentUseCases = action.payload
    },
    setCurrentTrendAnalysisFlag: (state, action) => {
      state.currentTrendAnalysisFlag = action.payload
    },
    setCurrentUserFeedbackFlag: (state, action) => {
      state.currentUserFeedbackFlag = action.payload
    },
    setCurrentChatbotFlag: (state, action) => {
      state.currentChatbotFlag = action.payload
    },
    setCurrentChatbotExportFlag: (state, action) => {
      state.currentChatbotExportFlag = action.payload
    },
    setCurrentChatbotCopyFlag: (state, action) => {
      state.currentChatbotCopyFlag = action.payload
    },
    setCurrentExportFlag: (state, action) => {
      state.currentExportFlag = action.payload
    },
    setCurrentPersonaFlag: (state, action) => {
      state.currentPersonaFlag = action.payload
    },
    setCustomLabels: (state, action) => {
      state.customLabels = action.payload
    },
    setCustomizationDefaultData: (state, action) => {
      state.customizationDefaultData = action.payload
    },
    setCustomizationData: (state, action) => {
      state.customizationData = action.payload
    },
    resetAdminPermission: () => initialState
  }
})

export const {
  setRefreshDashboard,
  setAdminPermissionLoading,
  setFilterData,
  setJurisdiction,
  setHealthCondition,
  setSdohData,
  setHealthAndEquityConditions,
  setStates,
  setSdoh,
  setCurrentJurisdiction,
  setCurrentDataAggregation,
  setCurrentHealthCondition,
  setCurrentSdoh,
  setCurrentPOI,
  setCurrentBenefits,
  setCurrentWorkforces,
  setUseCaseConfigData,
  setCurrentUseCases,
  setCurrentTrendAnalysisFlag,
  setCurrentUserFeedbackFlag,
  setCurrentChatbotFlag,
  setCurrentChatbotExportFlag,
  setCurrentChatbotCopyFlag,
  setCurrentExportFlag,
  setCurrentPersonaFlag,
  setCustomLabels,
  setCustomizationDefaultData,
  setCustomizationData,
  resetAdminPermission
} = adminPermissionSlice.actions

// Selectors
export const selectRefreshDashboard = (state) => state.adminPermission.refreshDashboard
export const selectAdminPermissionLoading = (state) => state.adminPermission.adminPermissionLoading
export const selectFilterData = (state) => state.adminPermission.filterData
export const selectJurisdiction = (state) => state.adminPermission.jurisdiction
export const selectHealthCondition = (state) => state.adminPermission.healthCondition
export const selectSdohData = (state) => state.adminPermission.sdohData
export const selectHealthAndEquityConditions = (state) => state.adminPermission.healthAndEquityConditions
export const selectStates = (state) => state.adminPermission.states
export const selectSdoh = (state) => state.adminPermission.sdoh
export const selectCurrentJurisdiction = (state) => state.adminPermission.currentJurisdiction
export const selectCurrentDataAggregation = (state) => state.adminPermission.currentDataAggregation
export const selectCurrentHealthCondition = (state) => state.adminPermission.currentHealthCondition
export const selectCurrentSdoh = (state) => state.adminPermission.currentSdoh
export const selectCurrentPOI = (state) => state.adminPermission.currentPOI
export const selectCurrentBenefits = (state) => state.adminPermission.currentBenefits
export const selectCurrentWorkforces = (state) => state.adminPermission.currentWorkforces
export const selectUseCaseConfigData = (state) => state.adminPermission.useCaseConfigData
export const selectCurrentUseCases = (state) => state.adminPermission.currentUseCases
export const selectCurrentTrendAnalysisFlag = (state) => state.adminPermission.currentTrendAnalysisFlag
export const selectCurrentUserFeedbackFlag = (state) => state.adminPermission.currentUserFeedbackFlag
export const selectCurrentChatbotFlag = (state) => state.adminPermission.currentChatbotFlag
export const selectCurrentChatbotExportFlag = (state) => state.adminPermission.currentChatbotExportFlag
export const selectCurrentChatbotCopyFlag = (state) => state.adminPermission.currentChatbotCopyFlag
export const selectCurrentExportFlag = (state) => state.adminPermission.currentExportFlag
export const selectCurrentPersonaFlag = (state) => state.adminPermission.currentPersonaFlag
export const selectCustomLabels = (state) => state.adminPermission.customLabels
export const selectCustomizationDefaultData = (state) => state.adminPermission.customizationDefaultData
export const selectCustomizationData = (state) => state.adminPermission.customizationData

export default adminPermissionSlice.reducer
